exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "instance-type-selector tr.unavailable {\n  opacity: 0.5;\n}\n", ""]);

